module.exports = __webpack_public_path__ + "static/media/ice3.711906fc.png";